import React, {useMemo} from 'react';

import {DocumentSubscribedStatusButton} from 'app/general/doc-status/DocumentSubscribedStatusButton';
import {rruleFromString} from 'app/tasks/utils';
import {gt} from 'app/utils/i18n';

import {ReadOnlyTaskTemplateSerializedType} from 'sweet-types';

type Props = {
  taskTemplate: ReadOnlyTaskTemplateSerializedType;
};

export function TaskSubscribedStatusButton({taskTemplate}: Props): JSX.Element {
  const onceOnly = useMemo(
    () => rruleFromString(taskTemplate.rrule).origOptions.count === 1,
    [taskTemplate.rrule]
  );
  return (
    <DocumentSubscribedStatusButton
      document={taskTemplate}
      contentType="tasktemplate"
      customTooltip={(isSubscribed) =>
        onceOnly || isSubscribed
          ? null
          : gt(
              'This is a recurring task. Once subscribed, you will receive notifications about all tasks in the series.'
            )
      }
    />
  );
}
